/**
 * 垂直排列推广中介卡片
 * 
 * @Author: Focci
 * @Date: 2023-07-31 09:09:19
 * @Last Modified by: Focci
 * @Last Modified time: 2023-07-31 09:09:19
 */

'use client'

import PropTypes from 'prop-types'
import Link from 'next/link'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import useApp from '@hook/useApp'
import Image from 'next/image'
import { useLocale, useTranslations } from 'next-intl'
import { parseAd } from '../ad/lib'

export default function ListingPromoteAd({
  data = {}
}) {
  const locale = useLocale()
  const { isMobile } = useApp()
  const ts = useTranslations('search')
  const url = parseAd(data, locale, isMobile)
  
  return (
    <Link 
      href={url} 
      className="flex flex-col rounded-md bg-white overflow-hidden h-full box-border shadow-listing"
    >
      <div className="relative bg-cf0 relative p-1 aspect-[600/450]">
        <div className="absolute inset-0">
          <Image 
            src={data?.cover_oss || ''}
            width={600}
            height={450}
            alt={data.title}
            className="object-contain w-full h-full"
          />
        </div>
      </div>
      <div className="px-2 py-4 flex justify-between">
        <div className="flex flex-col items-start gap-2">
          <span className="border border-ce6 px-1 rounded-sm text-helper text-f.6">
            {ts('promote')}
          </span>
          <div className="flex flex-col">
            <div>{data?.title}</div>
          </div>
        </div>
        <div className="px-1">
          <ArrowForwardIosIcon size={16} className="text-helper" />
        </div>
      </div>
    </Link>
  )
}

ListingPromoteAd.propTypes = {
  data: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]),
}
